import {extractOptionFromBC} from "../../common/utils";

export const generateCollections = (menu_item, bc_filter_tree) => {
    return menu_item && menu_item.collections_filter_key ? extractOptionFromBC(bc_filter_tree, menu_item.collections_filter_key) : [];
};

export const generateCollectionPrefix = (collection) => {
    return collection && collection.prefix ? collection.prefix.replace(/\\/g, "") : "";
};

export const generateExtra = (menu_item, bc_filter_tree) => {
    return menu_item && menu_item.extra_filter_key ? extractOptionFromBC(bc_filter_tree, menu_item.extra_filter_key) : [];
};

export const generateExtraPrefix = (extra) => {
    return extra && extra.prefix ? extra.prefix.replace(/\\/g, "") : "";
};